// This file should only contain action type constants.

export const SET_VEHICLE = 'SET_VEHICLE';
export const VCDA_ERROR = 'VCDA_ERROR';
export const SET_VEHICLE_VIEWS = 'SET_VEHICLE_VIEWS';
